import { h } from 'preact';
const Content = ({children, style}) => {

    return <article style={style}>{children}</article>
}
export default Content;


// WEBPACK FOOTER //
// ./components/Content.js